<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="NSS Committee"
                   :links="[{title:'Home', url:'/'},{title:'NSS Committee'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1 text-center">NATIONAL SERVICE SCHEME (NSS) COMMITTEE</div>
          <Divider/>
          <div class="heading-black2 font-serif mt-5">Constitution of Committee</div>
          <blockquote class="mt-4 text-gray-600 text-justify font-medium">
            <p>The NSS committee shall have following members</p>
          </blockquote>
          <div>
            <ul class="w-full text-gray-900 bg-white rounded-lg border border-gray-200 ">
              <li class="py-4 px-4 w-full rounded-t-lg border-b border-gray-200 text-justify hover:text-gray-700 hover:bg-gray-100">
                <i class="pi pi-arrow-circle-right mr-2"></i>One senior faculty from institute as a coordinator.
              </li>
              <li class="py-4 px-4 w-full rounded-t-lg border-b border-gray-200 text-justify hover:text-gray-700 hover:bg-gray-100">
                <i class="pi pi-arrow-circle-right mr-2"></i>One faculty member from each department as a member.
              </li>
              <li class="py-4 px-4 w-full rounded-t-lg border-b border-gray-200 text-justify hover:text-gray-700 hover:bg-gray-100">
                <i class="pi pi-arrow-circle-right mr-2"></i>One student representative as a student coordinator.
              </li>
            </ul>
          </div>
          <div class="heading-black2 font-serif pt-8">The Composition of NSS Committee</div>
          <Divider/>
          <div class="mt-4">
            <DataTable :value="Members" :rowHover="true">
              <Column field="no" header="#"></Column>
              <Column field="name" header="Name"></Column>
              <Column field="designation" header="Designation"></Column>
              <Column field="photo" header="Photo">
                <template #body="{data}">
                  <Image :src="data.photo" alt="Image" width="150" height="150"/>
                </template>
              </Column>
            </DataTable>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/nss/Sidebar.vue";
import Programmes from "@/views/about/Programmes";
import Divider from 'primevue/divider';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Image from 'primevue/image';

export default {
  name: "Committee",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    Programmes, Divider, DataTable, Column, Image
  },
  data() {
    return {
      Members: [
        {
          no: 1,
          name: 'Mr. Thakare Vishal R.',
          designation: 'Programme officer (Asst. Professor, Dept. of Mechanical Engg.)',
          photo: 'http://placehold.jp/150x150.png'
        },
        {
          no: 2,
          name: 'Mr. Gawande Yogesh B.',
          designation: 'Member (Asst. Professor, Dept. of  Civil  Engg.)',
          photo: 'http://placehold.jp/150x150.png'
        },
        {
          no: 3,
          name: 'Mr. Bharambe Ishwar N.',
          designation: 'Member (Asst. Professor, Dept. of Computer Engg.)',
          photo: 'http://placehold.jp/150x150.png'
        },
        {
          no: 4,
          name: 'Mr. Mutha Nikhil D.',
          designation: 'Member (Asst. Professor, Dept. of Electrical Engg.)',
          photo: 'http://placehold.jp/150x150.png'
        },
        {
          no: 5,
          name: 'Mr. Tathe Sachin G.',
          designation: 'Member (Asst. Professor, Dept. of I.T Engg.)',
          photo: 'http://placehold.jp/150x150.png'
        },
        {
          no: 6,
          name: 'Mr. Mule Pratik',
          designation: 'Student coordinator',
          photo: 'http://placehold.jp/150x150.png'
        }
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
